import { Validator } from './../interfaces/validations-dynamicform';
import {Option} from './../interfaces/options-dynamicform';

export class OrderFieldConfig {
    labelName: string;
    labelCode: string;
    sequence: number;
    inputType?: string;
    options?: Option[];
    type: string;
    value?: any;
    defaultValue? :any;
    displayFormat?: string;
    rangeMin?: number;
    rangeMax?: number;
    validations?: Validator[];
    hyphenPositions?: any[];
    description?: string;
    comment?: string;
    maxDate?: Date;
    minDate?: Date;
    minDateTimeError: boolean;
    maxDateTimeError: boolean;
    dateFormatError: boolean;
    originalMaxDate?: Date;
    originalMinDate?: Date;
    isScannable: boolean;
    disabled?:boolean;
}

export class OrderFormSection {
    sectionName: string;
    values: OrderFieldConfig[];
}

export class OrderFieldsRequest {
    requestType: string;
    orderAccountCode: string;
    orderAccountName: string;
    orderAccountId: string;
    packageAccountCode: string;
    packageAccountName: string;
    shipperType: string;
    trackingNumber: string;
    labSiteCode: string;
    requisitionId: string;
    isUpdate: boolean;
    template: string;
    usePrePrintedLabels: boolean;
    newrequisitionId: string;
}

export class OrderFormRequest {
    requestType: string;
    linkedAccountId: string;
    requisitionId: string;
    isUpdate: boolean;
    usePrePrintedLabels: boolean;
    template: string;
}

export class BulkOrderUploadRequest {
    requestType: string;
    orderAccountCode: string;
    orderAccountName: string;
    orderAccountId: string;
    packageAccountCode: string;
    packageAccountName: string;
    shipperType: string;
    trackingNumber: string;
    labSiteCode: string;
    isUpdate: boolean;
    template: string;
    usePrePrintedLabels: boolean;
    packageId?: string;
    isAddOrder: boolean;
}

export class Instructions{
    instructions: string;
}
